import { Component } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export interface MenuItemOptions {
  icon?: Component;
  height?: Number;
  width?: Number;
  iconClasses?: string;
  labelText: string;
  href?: string;
  to?: RouteLocationRaw;
  target?: '_blank' | '_self';
  closeOnClick?: boolean;
  click: () => void;
  labelClasses?: string;
}

export enum IconType {
  KEBAB = 'kebab',
  HAMBURGER = 'hamburger',
}
